import { useState } from 'react';

const navItems = [
  { label: '首页', href: '#top' },
  { label: '快讯流', href: '#kuaixun' },
  { label: '热点榜', href: '#remen' },
  { label: '内容专区', href: '#fenlei' },
  { label: '吃瓜互动', href: '#hudong' },
  { label: '投稿通道', href: '#tougao' },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [searchMsg, setSearchMsg] = useState('');

  const handleSearch = () => {
    if (!keyword.trim()) {
      setSearchMsg('请输入想查的关键词，例如「深夜同框」。');
      return;
    }
    setSearchMsg(`演示环境：已收到关键词「${keyword.trim()}」，搜索接口未接入。`);
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/92 backdrop-blur">
      <div className="flex items-center justify-between gap-3 h-16 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-lg">
            黑
          </span>
          <span className="leading-tight">
            <span className="block font-heading font-bold text-base text-foreground-950">黑料投稿</span>
            <span className="hidden sm:block text-[11px] text-foreground-500 tracking-wide">分类整理 · 快速筛选 · 每日更新</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-0.5">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 rounded-md text-sm text-foreground-700 hover:text-primary-600 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 shrink-0">
          <div className="relative">
            <button
              type="button"
              onClick={() => { setSearchOpen((v) => !v); setSearchMsg(''); }}
              className="w-9 h-9 rounded-md border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600 flex items-center justify-center transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line"></i>
            </button>
            {searchOpen ? (
              <div className="absolute right-0 top-11 w-72 md:w-80 rounded-lg border border-background-200 bg-background-50 p-3">
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    placeholder="搜索瓜料关键词"
                    className="flex-1 h-9 px-3 rounded-md border border-background-200 bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300"
                  />
                  <button
                    type="button"
                    onClick={handleSearch}
                    className="h-9 px-3 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                  >
                    搜索
                  </button>
                </div>
                {searchMsg ? <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{searchMsg}</p> : null}
              </div>
            ) : null}
          </div>

          <a
            href="#tougao"
            className="hidden sm:inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-add-line"></i>
            投稿入口
          </a>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-9 h-9 rounded-md border border-background-200 text-foreground-700 flex items-center justify-center cursor-pointer"
            aria-label="菜单"
          >
            <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 rounded-md border border-background-200 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#tougao"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex items-center justify-center gap-1.5 h-10 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
          >
            <i className="ri-add-line"></i>
            我要投稿
          </a>
        </div>
      ) : null}
    </header>
  );
}